import { BASE_CLASS_PREFIX } from '../base/constants';

const cssClasses = {
    PREFIX: `${BASE_CLASS_PREFIX}-pincode`
} as const;

const strings = {} as const;

const numbers = {

} as const;

export { cssClasses, strings, numbers };
